import React, { useMemo, useEffect, useState } from "react";
import {
    CustomAntCheckbox,
    CustomDeleteButton,
    DeleteIconArea,
    NotFoundDiv,
    SettingsName,
    SettingsValue,
    TickerItemDiv,
    NameSpan,
} from "./cPSettingsBlockStyles";
import { UnderlinedInput } from "components/Inputs/inputsStyles";
import { useAppSelector } from "hooks/redux";
import { useDispatch } from "react-redux";
import { SavedSettingsItem, setSavedCP } from "store/reducers/SettingsSlice";
import Loader from "components/Loader/Loader";
import reformatCPKeys from "utils/reformatCPKeys";
import Error from "utils/Notifications/Error";
import TPH from "utils/trade-params-handler";
import { saveCPSettingsItem } from "store/reducers/SettingsSlice";

const SettingsItem = ({
    name,
    currentValue,
    isInput = false,
    isCheckbox = false,
    onChange,
    onRemove,
    has_change,
}: any) => {
    const [isChanged, setIsChange] = useState(false);

    const middlewareInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.currentTarget.value);
    };

    useEffect(() => {
        const bool = typeof has_change === "boolean" ? has_change : false;
        setIsChange(bool);
    }, [has_change]);

    return (
        <TickerItemDiv>
            <SettingsName>
                <NameSpan>{name}</NameSpan>
            </SettingsName>
            <SettingsValue>
                {isInput && (
                    <UnderlinedInput
                        isChanged={isChanged}
                        onChange={(e) => middlewareInputChange(e)}
                        name={name}
                        type="text"
                        value={currentValue}
                        // defaultValue={currentValue}
                    />
                )}
                {isCheckbox && <CustomAntCheckbox type="checkbox" />}
            </SettingsValue>
            <DeleteIconArea>
                <CustomDeleteButton onClick={() => onRemove(name)} />
            </DeleteIconArea>
        </TickerItemDiv>
    );
};

function CPList({
    CPData,
    onRemove,
    id,
}: {
    CPData: SavedSettingsItem[];
    onRemove: Function;
    id: string;
}) {
    const {
        loading,
        error,
        savedSettings,
        MDPSelectedItem,
        activeGroup,
        activeTicker,
    } = useAppSelector((state) => state.settings);

    const dispatch = useDispatch();

    const handleValueChange = (value: string, key: string) => {
        const rawKey = key?.split(" ")[0];
        const valid = TPH._validate({ value, key: rawKey });
        const type = TPH.findParamType(rawKey);
        const { CP: localCP } = savedSettings;
        if (valid) {
            const newLocalValues = localCP[1].map((item, index) => {
                return index === reformatCPKeys(localCP[0]).indexOf(key)
                    ? value
                    : item;
            });
            const keys = localCP[0];
            const values = newLocalValues;
            const affiliation = {
                ticker_name: activeTicker?.name,
                group_name: activeGroup?.name,
            };
            dispatch(saveCPSettingsItem({ key, value, id, affiliation }));
            //dispatch(setSavedCP([keys, values]));
            return;
        }
        Error(`Неправильное значение. Тип поля: ${type}`);
    };

    const data = useMemo(() => {
        const list = [];

        for (const dat of CPData) {
            if (typeof dat.affiliation !== "object") {
                continue;
            }
            const affiliation = {
                ticker_name: activeTicker?.name,
                group_name: activeGroup?.name,
            };
            const keys = Object.keys(affiliation);

            if (
                keys.every((key) => affiliation[key] === dat.affiliation[key])
            ) {
                list.push(dat);
            }
        }
        return list;
    }, [activeTicker.name, activeGroup, CPData, MDPSelectedItem]);

    return (
        <>
            {loading && <Loader size="large" />}
            {error && <NotFoundDiv>{error}</NotFoundDiv>}
            {!loading &&
                Array.isArray(data) &&
                data.every((x) => typeof x !== "undefined") &&
                data?.map(({ key, value, has_change }) => (
                    <SettingsItem
                        key={`cp-item-${key}-x`}
                        name={key}
                        currentValue={value}
                        has_change={has_change}
                        isInput={true}
                        onRemove={() => onRemove(key, value)}
                        onChange={(redirectedValue: string) =>
                            handleValueChange(redirectedValue, key)
                        }
                    />
                ))}
        </>
    );
}

export default CPList;
